import React, { useContext } from 'react'
import { PERMISSIONS } from '@Const/permissions'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import ExpandableItem from '../../Sidebar/ExpandableItem'

const RoyaltiesSubNavigation = () => {
    const { rightsholderStore, rightsholderUserStore, userStore } = useContext(StoresContext)

    const currentRightsholderId = rightsholderStore.currentRightsholderId

    const hasManageContactPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address
    )
    const hasManageBankingPermission = rightsholderUserStore.doesRHUserHavePermissionOrIsInternal(
        PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax
    )

    return (
        <>
            {(!rightsholderStore.isRestricted || userStore.isInternal) &&
                (hasManageContactPermission || hasManageBankingPermission) && (
                    <ExpandableItem heading="Royalties" icon={ICONS.report}>
                        <NavLink end to={Navigation.rightholder.royalties.root(currentRightsholderId)}>
                            Summary
                        </NavLink>
                        <NavLink to={Navigation.rightholder.royalties.statements(currentRightsholderId)}>
                            Statements
                        </NavLink>
                        <NavLink to={Navigation.rightholder.royalties.annual(currentRightsholderId)}>
                            Annual Statements
                        </NavLink>
                        <NavLink to={Navigation.rightholder.royalties.rateSheets(currentRightsholderId)}>
                            Rate Sheets
                        </NavLink>
                    </ExpandableItem>
                )}
        </>
    )
}

export default observer(RoyaltiesSubNavigation)
